import type { RaspadinhaCampaign } from '@/types/raspadinha-campaign'
import {
  getDefaultContemplatedPrizeExamples,
  getDefaultRaspadinhaMediaFields,
  RASPADINHA_DEFAULT_PRIMARY_COLOR,
  RASPADINHA_DEFAULT_SECONDARY_COLOR,
} from './default-media-examples'
import { withRaspadinhaExampleCampaignLabel } from './raspadinha-example-label'

export const GARFO_INOX_EXAMPLE_CAMPAIGN_NAME = withRaspadinhaExampleCampaignLabel(
  'Raspadinha Garfo Inox'
)

export const GARFO_INOX_LIMITED_EXAMPLE_CAMPAIGN_NAME = withRaspadinhaExampleCampaignLabel(
  'Raspadinha Garfo Inox — Edição Limitada'
)

export const GARFO_INOX_PRIZE_LABEL = withRaspadinhaExampleCampaignLabel('Garfo Inox')

/** Textos e identidade visual do exemplo Garfo Inox (sem nome/slug/id). */
export const GARFO_INOX_EXAMPLE_CONTENT: Pick<
  RaspadinhaCampaign,
  | 'title'
  | 'description'
  | 'prize_description'
  | 'primary_color'
  | 'secondary_color'
  | 'email_template_subject'
  | 'email_template_body'
  | 'public_page_url'
> = {
  title: withRaspadinhaExampleCampaignLabel('Raspe e ganhe um Garfo Inox'),
  description: withRaspadinhaExampleCampaignLabel(
    'Promoção digital de raspadinha com prêmio instantâneo. Raspe a cartela, descubra na hora se você contemplou um garfo inox premium.'
  ),
  prize_description: withRaspadinhaExampleCampaignLabel(
    'Garfo inox com acabamento premium e design ergonômico. Cada contemplação garante um unitário para retirada ou envio conforme o regulamento.'
  ),
  primary_color: RASPADINHA_DEFAULT_PRIMARY_COLOR,
  secondary_color: RASPADINHA_DEFAULT_SECONDARY_COLOR,
  email_template_subject: withRaspadinhaExampleCampaignLabel(
    'Sua cartela da Raspadinha Garfo Inox está pronta'
  ),
  email_template_body: withRaspadinhaExampleCampaignLabel(
    'Olá {{nome}}, obrigado por participar da Raspadinha Garfo Inox. Raspe sua cartela digital e confira se você foi contemplado com um garfo inox premium.'
  ),
  public_page_url: '/raspadinha/raspadinha-garfo-inox',
}

export const GARFO_INOX_LIMITED_EXAMPLE_CONTENT: Pick<
  RaspadinhaCampaign,
  | 'title'
  | 'description'
  | 'prize_description'
  | 'email_template_subject'
  | 'email_template_body'
  | 'public_page_url'
> = {
  title: withRaspadinhaExampleCampaignLabel('Edição limitada — Garfo Inox exclusivo'),
  description: withRaspadinhaExampleCampaignLabel(
    'Versão em rascunho da campanha Garfo Inox com estoque reduzido de prêmios para testes de configuração.'
  ),
  prize_description: withRaspadinhaExampleCampaignLabel(
    'Garfo inox edição limitada com gravação exclusiva da promoção. Quantidade restrita de contemplações.'
  ),
  email_template_subject: withRaspadinhaExampleCampaignLabel(
    'Rascunho — Raspadinha Garfo Inox Edição Limitada'
  ),
  email_template_body: withRaspadinhaExampleCampaignLabel(
    'Olá {{nome}}, este é um modelo de e-mail da edição limitada Garfo Inox. Ajuste o texto antes de publicar a campanha.'
  ),
  public_page_url: '/raspadinha/raspadinha-garfo-inox-edicao-limitada',
}

export function getGarfoInoxExampleMediaAndPrizes(): Pick<
  RaspadinhaCampaign,
  | 'welcome_image_url'
  | 'background_image_url'
  | 'contemplated_image_url'
  | 'not_contemplated_image_url'
  | 'contemplated_prize_images'
> {
  return {
    ...getDefaultRaspadinhaMediaFields(),
    contemplated_prize_images: getDefaultContemplatedPrizeExamples(),
  }
}
